import React, { useState } from 'react';
import { formatCurrency, generateId, translate } from '../../../../utility/functions';
import { BorderLessButton } from '../../../../forms/Button';
import Row from '../../../../layout/Row';
import Col from '../../../../layout/Col';

const DailyDrop = ({ label, quantity, price, discount, discountType, locations, ...props }) => {

    const [dropped, setDropped] = useState(false);

    return (
        <>
            <td>
                <BorderLessButton
                    label={label}
                    onClick={() => setDropped(!dropped)}
                />
            </td>
            <td>
                <Col>
                    {
                        dropped ?
                            locations.map(h => h.map(i => (
                                <Row key={generateId()}>
                                    <span>{i.quantity} - {i.location}</span>
                                </Row>
                            ))) :
                            quantity.map(e => <span key={generateId()}>{e}</span>)
                    }
                </Col>
            </td>
            {price ?
                <td>
                    <Col>
                        {price.map((e, i) => {
                            let additional = []
                            if (dropped && locations[i].length > 1) {
                                additional = [...locations[i]]
                                additional.length = locations[i].length - 1;
                            }
                            return (
                                <div key={generateId()}>
                                    <span>{e}  {discount[i] ? `- (${formatCurrency(discount[i])} ${translate(discountType[i])})` : ''}</span>
                                    {additional.map(f => <span key={generateId()}>-</span>)}
                                </div>
                            )
                        })}
                    </Col>
                </td> :
                null}
        </>
    );
}

export default DailyDrop;